var React = require('react');

var ReadMore = React.createClass({

  downArrow: <i className="fa fa-angle-down"></i>,
  upArrow: <i className="fa fa-angle-up"></i>,
  
  getInitialState: function(){
    return {
      expanded: false,
      readMoreLessLabel: this.downArrow,
      style: {
        height: (this.props.initialHeight) ? this.props.initialHeight : '80px',
        overflow: 'hidden'
      }
    };
  },

  toggle: function(e) {
    e.preventDefault();

    var expanded = ! this.state.expanded;
    var label = expanded ? this.upArrow : this.downArrow;
    var elem = this.refs.content.getDOMNode();
    var style = this.state.style;

    if (!expanded) {
      style = this.getInitialState().style;
    } else {
      style = { height: 'auto', overflow: 'initial' };
    }
    
    this.setState({
      expanded: expanded,
      readMoreLessLabel: label,
      style: style
    });

  },
  
  render: function() {

    return (
      <div className={this.props.className}>
        <div onClick={this.toggle} ref="content" dangerouslySetInnerHTML={{__html: this.props.content}} style={this.state.style} />
        <a onClick={this.toggle} className="read-more" href="#" >{this.state.readMoreLessLabel}</a>
      </div>
    );
  }
});

module.exports = ReadMore;



// WEBPACK FOOTER //
// ./components/readmore.js